<template>
    <div class="priceSummary">
        <p class="h1" v-html="dataPriceSummary.price" />
        <p class="subline">{{ dataPriceSummary.subline }}</p>
        <v-tooltip
            content-class="tooltip"
            :close-delay="delayClose"
            :max-width="600"
            :nudge-bottom="20"
            bottom
        >
            <template v-slot:activator="{ on }">
                <span
                    class="priceSummary__link"
                    v-on="on"
                    @click.once="
                        () =>
                            trackEventForUserActions(
                                'Price Summary',
                                dataPriceSummary.readmore,
                                '',
                            )
                    "
                    v-html="dataPriceSummary.readmore"
                />
            </template>
            <span v-html="dataPriceSummary.tooltip" />
        </v-tooltip>
    </div>
</template>

<script>
import gtmTracking from '@/mixins/gtmTracking'
import {
    BASE_PRICE_PER_HOUR,
    PREFIX_BASE_PRICE_PER_HOUR,
} from '@/data/constants'

export default {
    name: 'PriceSummary',
    mixins: [gtmTracking],
    data: () => ({
        dataPriceSummary: {
            price: `${[PREFIX_BASE_PRICE_PER_HOUR, BASE_PRICE_PER_HOUR]
                .filter(s => s !== '')
                .join(' ')}&#8239;€ / Stunde`,
            subline: '1 Stunde kostenfrei für Neukundinnen und Neukunden',
            readmore: 'Wie setzt sich dieser Preis zusammen?',
            tooltip:
                'Die Alltagshilfe verdient 20 € die Stunde. Careship erhält 8 € Provision für die Akquise und das Management der Kunden. In München verdienen Alltagshilfen 22,50 € und die Provison für Careship beträgt 10,50 €.',
        },
    }),
    computed: {
        delayClose() {
            return this.$vuetify.breakpoint.smAndDown ? 0 : 600
        },
    },
}
</script>

<style lang="stylus">
.priceSummary {
    text-align: center;
    position: relative;
    .h1 {
        color: $cs-secondary;
        margin: 0 0 $cs-spaces.half;
    }
    .subline {
        font-size: 16px;
        font-weight: bold;
        color: $cs-secondary;

        @media $display-breakpoints.md-and-up {
            font-size: 20px;
        }
    }
    &__link {
        color: $cs-slate-300;
        display: block;
        font-size: 14px;
        margin: 0 auto;
        max-width: 220px;
        text-decoration: underline;
        transition: all ease-in-out 200ms;
        @media $display-breakpoints.sm-and-up {
            font-size: inherit;
            max-width: fit-content;
        }
        &:hover {
            color: $cs-primary;
            text-decoration: none;
        }
    }
}
</style>
